function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledBlogCardItemComponent } from "./blog-card-item-component.scss";
import GridImage from "segments/desktop/core-components/grid-image/grid-image";
import Title from "segments/desktop/core-components/title/title";
import BlogCardItemFooterComponent from "./blog-card-item-footer/blog-card-item-footer-component";
import { XS } from "constants/sizes";
import Button from "segments/desktop/core-components/button/button";
const IMAGE_HEIGHT = "100%";
const IMAGE_WIDTH = "100%";
class BlogCardItemComponent extends PureComponent {
    render() {
        const { link, image, title, openInNewTab, imageMaxHeight } = this.props;
        return /*#__PURE__*/ _jsxs(StyledBlogCardItemComponent, {
            className: "blog-card-item-component",
            href: link,
            target: openInNewTab ? "_blank" : "_self",
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave,
            children: [
                (image === null || image === void 0 ? void 0 : image.src) && /*#__PURE__*/ _jsx("div", {
                    className: "grid-image-wrapper-component",
                    style: {
                        maxHeight: imageMaxHeight
                    },
                    children: /*#__PURE__*/ _jsx(GridImage, _object_spread_props(_object_spread({}, image), {
                        height: IMAGE_HEIGHT,
                        width: IMAGE_WIDTH
                    }))
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "blog-card-item-content",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "title-component-wrapper",
                            children: /*#__PURE__*/ _jsx(Title, {
                                title: title,
                                titleSize: XS
                            })
                        }),
                        this.renderFooterIfNeeded()
                    ]
                })
            ]
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "onMouseEnter", ()=>{
            this.setState({
                isCardHoverd: true
            });
        });
        _define_property(this, "onMouseLeave", ()=>{
            this.setState({
                isCardHoverd: false
            });
        });
        _define_property(this, "renderFooterIfNeeded", ()=>{
            const { isCardHoverd } = this.state;
            const { footer, hideFooter, buttonConfig } = this.props;
            const hasButtonConfig = buttonConfig === null || buttonConfig === void 0 ? void 0 : buttonConfig.buttonType;
            if (hideFooter && !hasButtonConfig) return null;
            return /*#__PURE__*/ _jsx("div", {
                className: "blog-footer-wrapper",
                children: hasButtonConfig ? /*#__PURE__*/ _jsx("div", {
                    className: "button-container",
                    children: /*#__PURE__*/ _jsx(Button, _object_spread({}, buttonConfig))
                }) : /*#__PURE__*/ _jsx(BlogCardItemFooterComponent, _object_spread_props(_object_spread({}, footer), {
                    isCardHoverd: isCardHoverd
                }))
            });
        });
        this.state = {
            isCardHoverd: false
        };
    }
}
export { BlogCardItemComponent as default };
